export enum DeleteMessageDelayEnum {
  Near = 'Near',
  NextFirstDay = 'NextFirstDay',
  NextFirstOrSecondDay = 'NextFirstOrSecondDay',
}
